import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { useEffect, useState } from "react";
import { ExpenseCategoriesFormValues } from "src/models/ExpenseCategories.model";
import {
  useEditExpenseCategoryMutation,
  useGetExpenseCategoryByIdQuery,
} from "src/services/ExpenseCategoryServices";
import { showToast } from "src/utils/showToaster";
import { object, string } from "yup";
import ExpenseCategoriesForm from "../Layouts/ExpenseCategoriesForm";
import CircularProgress from "@mui/material/CircularProgress";

type Props = {
  onClose: () => void;
  categoryId: string;
};

const EditExpenseCategoriesFormWrapper = ({ onClose, categoryId }: Props) => {
  const [editExpenseCategory] = useEditExpenseCategoryMutation(); //expense category edit mutation
  const { data, isLoading, isFetching } = useGetExpenseCategoryByIdQuery({
    id: categoryId,
  }); //query for getting single category data

  const [categoryData, setCategoryData] = useState<any>();

  //setting single category data
  useEffect(() => {
    if (!isFetching && !isLoading) {
      setCategoryData(data?.data);
    }
  }, [data, isLoading, isFetching]);

  // Form Initial Values
  const initialValues: ExpenseCategoriesFormValues = {
    categoryName: categoryData?.categoryName || "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    categoryName: string().required("Please enter category name"),
  });

  // Handle Submit
  const handleSubmit = (
    values: ExpenseCategoriesFormValues,
    { setSubmitting, resetForm }: FormikHelpers<ExpenseCategoriesFormValues>
  ) => {
    editExpenseCategory({
      body: values,
      id: categoryId,
    }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {(formikProps) => (
          <Form>
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <ExpenseCategoriesForm
              formikProps={formikProps}
              onClose={onClose}
              formType="Add"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditExpenseCategoriesFormWrapper;
